<script setup>
import {envSettings} from "@utils/utils.js";
import {computed, toRefs} from "vue";
import {styleClassMap} from "@utils/mapping.js";

const props = defineProps({
  logo: {
    type: String,
    default: `${envSettings.IMG_ROOT}/logoWhite.svg`
  },
  pageStyle: {
    type: String,
    default: 'default'
  }
});
const {logo, pageStyle} = toRefs(props);
const customClass = computed(() => styleClassMap.get(pageStyle.value) || '')
</script>

<template lang="pug">
  .header(:class="customClass")
    img.logo(:src="logo || `${envSettings.IMG_ROOT}/public/logoWhite.svg`", alt="logo")
</template>

<style scoped lang="sass">
@use '@assets/styles/common' as *
.header.lite
  background-color: unset

.header.tutor
  background-color: #191919

</style>
